// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__113ec","buttons":"styles_buttons__Cvrgz"};